import React from 'react';
import { Container } from 'react-bootstrap';
import { Row, Col } from 'reactstrap';

function Footer(){
    return(
        <div className="footer">
           <Container className="container">
                <Row>
                    <Col xs={12} md={4} id="links">
                        <h3>Useful Links:</h3>
                        <a href="#home">Home</a>
                        <a href="#about">About</a>
                        <a href="#education">Education</a>
                        <a href="#certificates">Certificates</a>
                        <a href="#Projects">Projects</a>
                    </Col>
                    <Col xs={12} md={4}>
                        <h3>Address:</h3>
                        <p>61, Rajgad Hostel </p>
                        <p>Sinhgad Institute of Technology</p>
                        <p>Lonavala, Pune</p>
                        <p>INDIA , 410401 </p>
                    </Col>
                    <Col xs={12} md={4}>
                        <h3>Contact Me:</h3>
                        <p>Call Me : +91 8795474764</p>
                        <p>Mail ID : saurabhmishra6179@gmail.com</p>
                        <p><a href="https://github.com/samdevlops">Github</a></p>
                        <p><a href="https://twitter.com/_mishra_saurabh">Twitter</a></p>
                        <p><a href="https://www.instagram.com/prince_sm07/">Instagram</a></p>
                        <p><a href="https://github.com/samdevlops">Facebook</a></p>
                    </Col>
                </Row>
           </Container>
           <hr id="ridge"></hr>
           <div className="copyright">   
                <p>Made with <span role="img">❤️</span> by <a href="https://github.com/samdevlops">samdevlops.</a></p>
           </div>
        </div>
    )
}

export default Footer;